import { render, staticRenderFns } from "./PowerBIReport.vue?vue&type=template&id=58575d34&scoped=true"
import script from "./PowerBIReport.vue?vue&type=script&lang=js"
export * from "./PowerBIReport.vue?vue&type=script&lang=js"
import style0 from "./PowerBIReport.vue?vue&type=style&index=0&id=58575d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58575d34",
  null
  
)

export default component.exports